import React, { useEffect, useState, useContext } from "react";
import VisualSuggest from "../../../Components/SuggestionVisual/SuggestionVisual";
import SectionItemToolbar from "../../../Components/GlobalSectionToolbar/SectionItemToolbar";
import { ResumePopupContext } from "../../../Context/resumePopupContext";
import SectionHeader from "../SectionHeader/sectionHeader";
import WorkExperienceItem from "./WorkExperienceItem";
import SectionItemWrapper from "../SectionItemWrapper/SectionItemWrapper";

function WorkExperience(props) {
  const {
    resumeFields,
    sectionId,
    resumeTitleHandler,
    handleEditorChange,
    resumeHandler,
    resumeUpdate,
    dateHandler,
    styles,
    settings,
    contentAdder,
    handleSliderChange,
    PageMargin,
    SectionMargin,
    layout,
  } = props;

  const { setSuggestionIndex } = useContext(ResumePopupContext);

  const { experience } = settings;

  const [focusIndex, setFocusIndex] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [isSelectedFrom, setIsSelectedFrom] = useState(true);
  const [showSuggest, setShowSuggest] = useState(false);

  const [showQuillToolbar, setShowQuillToolbar] = useState(true);

  const changesetShowQuillToolbar = (status) => {
    setShowQuillToolbar(status);
  };

  const innerSectionClick = (e, index) => {
    setSuggestionIndex(index);
    props.changeFocusStyle(props.sectionId, index.toString(), "item");
  };

  useEffect(() => {
    setFocusIndex(false);
  }, []);

  const handleDatePicker = (selected) => {
    if (selected == "from") {
      setIsSelectedFrom(true);
    } else {
      setIsSelectedFrom(false);
    }
    setShowDatePicker(!showDatePicker);
  };

  const WorkExperienceItemsRef = {};
  const handleSuggestion = (job, index) => {
    setShowSuggest(true);
    setSuggestionIndex(index);
  };

  const hideSuggest = () => {
    setShowSuggest(false);
  };
  useEffect(() => {
    if (props.newSectionFocus != props.sectionId) {
      setShowSuggest(false);
      setShowDatePicker(false);
      setIsSelectedFrom(true);
    }
  }, [props.newSectionFocus]);

  return (
    <>
      {resumeFields && resumeFields.show && (
        <>
          <SectionHeader
            styles={styles}
            settings={settings}
            resumeFields={resumeFields}
            sectionId={sectionId}
            resumeTitleHandler={resumeTitleHandler}
            resumeUpdate={resumeUpdate}
            PageMargin={PageMargin}
            SectionMargin={SectionMargin}
          />
          <div className="section-item-wrapper experience-item-wrapper">
            {props &&
              props.response &&
              props.response.itemIndexes.map(
                (result, ind) =>
                  resumeFields &&
                  resumeFields.data &&
                  resumeFields.data.map((response, index, row) =>
                    index == result ? (
                      <SectionItemWrapper
                        sectionId={sectionId}
                        styles={styles}
                        layout={layout}
                        index={index}
                        newSectionFocus={props.newSectionFocus}
                        currentStateFocus={props.currentStateFocus}
                        newItemFocus={props.newItemFocus}
                        SectionMargin={SectionMargin}
                        isFixedPaddingBottom={true}
                        paddingBottom={"15px"}
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={(e) => {
                          e.stopPropagation();
                          innerSectionClick(e, index);
                        }}
                        style={{ position: "relative" }}
                      >
                        {/* <div
                          key={`workexperience-item${index}`}
                          ref={(ref) => (WorkExperienceItemsRef[index] = ref)}
                          className={`experience-item resume-item ${
                            props.newSectionFocus == props.sectionId &&
                            props.currentStateFocus == "item" &&
                            props.newItemFocus &&
                            props.newItemFocus == index.toString()
                              ? "sectionFocusStyle"
                              : ""
                          }`}
                          id={`experience-${index}`}
                          onMouseDown={(e) => e.stopPropagation()}
                          onClick={(e) => {
                            e.stopPropagation();
                            innerSectionClick(e, index);
                          }}
                        > */}
                        {showQuillToolbar &&
                          props.newSectionFocus == props.sectionId &&
                          props.currentStateFocus == "item" &&
                          props.newItemFocus &&
                          props.newItemFocus == index.toString() && (
                            <>
                              <SectionItemToolbar
                                index={index}
                                indexString={index.toString()}
                                handleDelete={props.handleItemDelete}
                                sectionItemMoveUp={props.sectionItemMoveUp}
                                sectionItemMoveDown={props.sectionItemMoveDown}
                                addAdditionalField={props.addAdditionalField}
                                row={row}
                                sectionId={props.sectionId}
                                newSectionFocus={props.newSectionFocus}
                                startFrom={response.startFrom}
                                endUntil={response.endUntil}
                                resumeUpdate={resumeUpdate}
                                dateHandler={dateHandler}
                                response={response}
                                changeSettings={props.changeSettings}
                                showDatePicker={showDatePicker}
                                isSelectedFrom={isSelectedFrom}
                                className="ql-bold"
                                handleSliderChange={handleSliderChange}
                              />
                            </>
                          )}

                        {showQuillToolbar &&
                          props.newSectionFocus == props.sectionId &&
                          props.currentStateFocus == "item" &&
                          props.newItemFocus &&
                          props.newItemFocus == index.toString() && (
                            <p
                              className="suggestion-text-experience"
                              onClick={() =>
                                handleSuggestion(response.position, index)
                              }
                            >
                              Show Suggestions
                              <i
                                class="fa fa-plus-circle basic-suggestion-add-icon"
                                aria-hidden="true"
                              ></i>
                            </p>
                          )}
                        {showSuggest &&
                          showSuggest &&
                          props.newSectionFocus == props.sectionId &&
                          props.newItemFocus == index.toString() && (
                            <VisualSuggest
                              job={response.position}
                              sectionId={props.sectionId}
                              index={index}
                              hideSuggest={hideSuggest}
                              showSuggest={showSuggest}
                              contentAdder={contentAdder}
                            />
                          )}
                        {
                          <WorkExperienceItem
                            headerHtml={experience?.headerStyle}
                            styles={styles}
                            resumeHandler={resumeHandler}
                            resumeUpdate={resumeUpdate}
                            response={response}
                            index={index}
                            handleDatePicker={handleDatePicker}
                            handleEditorChange={handleEditorChange}
                            changesetShowQuillToolbar={
                              changesetShowQuillToolbar
                            }
                            showQuillToolbar={showQuillToolbar}
                            sectionId={props.sectionId}
                          />
                        }
                        {/* </div> */}
                      </SectionItemWrapper>
                    ) : (
                      ""
                    )
                  )
              )}
          </div>
        </>
      )}
    </>
  );
}

export default WorkExperience;
